import React from 'react';
import DatePicker from 'react-datepicker';
import { useBooking } from '../context/BookingContext';
import { format, parseISO } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";

const CustomDatePicker = () => {
  const { state, dispatch } = useBooking();

  const handleCheckinChange = (date) => {
    if (!date) return;
    
    let newCheckout = state.searchState.checkout;
    
    // If checkout is before or same as new checkin, adjust checkout
    if (newCheckout && newCheckout <= date) {
      newCheckout = new Date(date);
      newCheckout.setDate(newCheckout.getDate() + 1);
    }

    dispatch({
      type: 'UPDATE_SEARCH_STATE',
      payload: {
        checkin: date,
        checkout: newCheckout || new Date(date.getTime() + 86400000)
      }
    });

    // Auto-trigger search after date change
    setTimeout(() => {
      dispatch({ type: 'PERFORM_SEARCH', payload: {} });
    }, 300);
  };

  const handleCheckoutChange = (date) => {
    if (!date) return;
    
    dispatch({
      type: 'UPDATE_SEARCH_STATE',
      payload: { checkout: date }
    });
    
    // Auto-trigger search after date change
    setTimeout(() => {
      dispatch({ type: 'PERFORM_SEARCH', payload: {} });
    }, 300);
  };

  // Custom input component to match your styling
  const CustomInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
    <div className="relative w-full">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 text-gray-400">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
        </svg>
      </div>
      <input
        type="text"
        className="w-full h-10 pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm bg-white cursor-pointer focus:outline-none focus:ring-1 focus:ring-brand-accent focus:border-brand-accent"
        onClick={onClick}
        ref={ref}
        value={value}
        placeholder={placeholder}
        readOnly
      />
    </div>
  ));

  CustomInput.displayName = 'CustomInput';

  const minCheckoutDate = state.searchState.checkin 
    ? new Date(state.searchState.checkin.getTime() + 86400000)
    : new Date(new Date().getTime() + 86400000);

  return (
    <>
      {/* Check-in Date */}
      <div>
        <label className="block text-xs font-semibold text-text-secondary mb-1 uppercase tracking-wider">
          Check-in
        </label>
        <DatePicker
          selected={state.searchState.checkin}
          onChange={handleCheckinChange}
          minDate={new Date()}
          dateFormat="dd-MM-yy"
          placeholderText="DD-MM-YY"
          customInput={<CustomInput />}
          className="w-full"
          popperPlacement="bottom-start"
        />
      </div>

      {/* Check-out Date */}
      <div>
        <label className="block text-xs font-semibold text-text-secondary mb-1 uppercase tracking-wider">
          Check-out
        </label>
        <DatePicker
          selected={state.searchState.checkout}
          onChange={handleCheckoutChange}
          minDate={minCheckoutDate}
          dateFormat="dd-MM-yy"
          placeholderText="DD-MM-YY"
          customInput={<CustomInput />}
          className="w-full"
          popperPlacement="bottom-start"
        />
      </div>
    </>
  );
};

export default CustomDatePicker;